import { Component, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-menu-page-search',
  templateUrl: './page-search.component.html',
  styleUrls: ['./page-search.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: PageSearchComponent,
    multi: true
  }]
})
export class PageSearchComponent implements ControlValueAccessor {

  @Input() value: string;
  @Input() searchLabel;

  constructor() {
  }

  writeValue(obj: any): void {
  }

  registerOnChange(fn: any): void {
  }

  registerOnTouched(fn: any): void {
  }
}
